import _ from 'underscore';
import defaultTemplate from 'text!./templates/address-details-default.html';
import bigToSmallTemplate from 'text!../../../../../../../../common/js/src/edge/platform/widgets/inputs/templates/address-details-BigToSmall.html';
import postCodeBeforeCityTemplate from 'text!../../../../../../../../common/js/src/edge/platform/widgets/inputs/templates/address-details-PostCodeBeforeCity.html';

export default ['LocaleService', function (LocaleService) {
    var addressConfig = LocaleService.getAddressConfig();
    var template = void 0;

    switch (addressConfig.pcfMode) {
        case 'BigToSmall':
            template = bigToSmallTemplate;
            break;
        case 'PostCodeBeforeCity':
            template = postCodeBeforeCityTemplate;
            break;
        default:
            template = defaultTemplate;
            break;
    }

    return {
        restrict: 'AE',
        template: template,
        scope: {
            address: '=',
            allContacts: '=',
            readonly: '@',
            addressType: '@',
            displayCountry: '@',
            defaultCountryCode: '@',
            disableZipCode: '=',
            disableCity: '=',
            disableState: '=',
            showLoading: '=',
            hideFields: '=',
            placeholders: '=?',
            postalCodeErrorMessage: '@?',
            postalCodeValidity: '=?'
        },

        link: function link(scope, element, attrs) {
            attrs.$observe('readonly', function (value) {
                scope.readonly = value === 'true';
            });

            var defaultCountryCode = scope.defaultCountryCode || LocaleService.getCountry().code;

            scope.isVisible = function (fieldName) {
                var visible = addressConfig.fieldNames.indexOf(fieldName) >= 0;
                if (scope.hideFields) {
                    visible = visible && !(_.contains(scope.hideFields, fieldName) || _.contains(_.map(scope.hideFields, function (idx) {
                        return idx + 'Kanji';
                    }), fieldName));
                }
                return visible;
            };

            scope.shouldShow = function (value) {
                return angular.isDefined(value.value);
            };

            function syncAddressData() {
                if (scope.address.value) {
                    scope.address.country.value = scope.address.country.value || defaultCountryCode;
                } else {
                    scope.address.value = {
                        country: defaultCountryCode
                    };
                }
            }

            scope.$watch('address.value', syncAddressData);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/AddressDetails.js
// module id = 769
// module chunks = 0